import axios from '../plugins/axios';

/** Backend: cashier settlements (تسليم عهدة) */
const RESOURCE = '/admin/cashier-settlements';

/** Eager-load relations on read (same pattern as other admin list APIs) */
const WITH_RELATIONS = {
  '_with_[creator]': '',
  '_with_[approver]': ''
};

export default {
  list(params = {}) {
    return axios.get(RESOURCE, {
      params: {
        ...WITH_RELATIONS,
        ...params
      }
    });
  },

  getById(id) {
    return axios.get(`${RESOURCE}/${id}`, {
      params: { ...WITH_RELATIONS }
    });
  },

  create(payload) {
    return axios.post(RESOURCE, payload);
  },

  update(id, payload) {
    return axios.put(`${RESOURCE}/${id}`, payload);
  },

  remove(id) {
    return axios.delete(`${RESOURCE}/${id}`);
  },

  /** Body: { approve_note?: string } — يطابق خانة الملاحظة عند الإعتماد في الـ API */
  approve(id, body = {}) {
    return axios.post(`${RESOURCE}/${id}/approve`, body);
  }
};
